import React, { useState } from 'react';

export default function SelectScrollBar({ label = 'Daftar Item',
  options = [],
  height = 150,
  width = 400,
  fontSize = 14,
}) {
  const [searchText, setSearchText] = useState('');

  // Filter opsi berdasarkan pencarian
  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div style={{ width: width, maxWidth: '100%' }}>
      {label && (
        <label
          style={{
            fontWeight: 'bold',
            marginBottom: 8,
            display: 'block',
            fontSize: fontSize,
          }}
        >
          {label}
        </label>
      )}

      {/* Search Box */}
      <input
        type="text"
        placeholder="Cari..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{
          width: '100%',
          padding: 8,
          fontSize: fontSize - 2,
          marginBottom: 10,
          borderRadius: 4,
          border: '1px solid #ccc',
        }}
      />

      {/* Readonly Scroll Box */}
      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: 4,
          padding: 10,
          height: height,
          overflowY: 'auto',
          backgroundColor: '#f9f9f9',
          cursor: 'not-allowed',
          whiteSpace: 'pre-wrap',
          fontSize: fontSize,
          lineHeight: '1.8',
        }}
      >
        {filteredOptions.length > 0
          ? filteredOptions.map((opt, idx) => `${idx + 1}. ${opt.label}`).join('\n')
          : 'Tidak ditemukan'}
      </div>
    </div>
  );
}
